import { queryOptions } from '@tanstack/react-query';

import { sharedApi } from '../apis/shared.api';
import {
  Globals,
  useQueriesWithGlobal,
} from '../hooks/use-queries-with-globals/queries-with-global';

export const sharedQueries = (globals: Globals) => ({
  all: [globals, 'shared'],

  computationRequests: () => [
    ...sharedQueries(globals).all,
    'computationRequests',
  ],
  computationRequest: (args: { id: number }) =>
    queryOptions({
      queryKey: [...sharedQueries(globals).computationRequests(), args.id],
      queryFn: () => sharedApi.getComputationStatus(args.id),
      refetchInterval: (query) => {
        // refetch while status !== 'FINISHED'
        return query.state.data?.status === 'FINISHED' ? false : 5000;
      },
    }),
});

export const useSharedQueries = () => {
  return useQueriesWithGlobal(sharedQueries);
};
